import { render, staticRenderFns } from "./CategorySearchOptions.vue?vue&type=template&id=fffe5b16&scoped=true"
import script from "./CategorySearchOptions.vue?vue&type=script&lang=js"
export * from "./CategorySearchOptions.vue?vue&type=script&lang=js"
import style0 from "./CategorySearchOptions.vue?vue&type=style&index=0&id=fffe5b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffe5b16",
  null
  
)

export default component.exports